module.exports = __webpack_public_path__ + "static/media/jeff4.a201199d.jpg";